import { render } from "./right.svg?vue&type=template&id=8729de0a"
const script = {}

import exportComponent from "/buddy/grau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__